import React from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './Tips.module.css';

export default class Tips extends React.Component {
  state = {
    tips: 'info',
    message: '',
    hideResolve: null,
    timer: null,
  };

  show(type, message) {
    if (this.state.timer) {
      clearTimeout(this.state.timer);
    }
    if (this.state.hideResolve) {
      this.state.hideResolve();
    }

    return new Promise(resolve => {
      const timer = setTimeout(() => {
        this.setState({ hideResolve: null, timer: null });
        resolve();
      }, 3000);

      this.setState({
        hideResolve: resolve,
        timer,
        type,
        message,
      });
    });
  }

  renderIcon() {
    const { type } = this.state;
    let icon = null;

    if (type === 'info') {
      icon = <span className={styles.iconInfo} />;
    } else if (type === 'error') {
      icon = <span className={styles.iconError} />;
    } else if (type === 'succ') {
      icon = <span className={styles.iconSucc} />;
    } else if (type === 'warn') {
      icon = <span className={styles.iconWarn} />;
    }

    return icon;
  }

  render() {
    const { message, hideResolve } = this.state;

    return (
      <CSSTransition
        in={!!hideResolve}
        timeout={200}
        classNames={{
          enter: styles.modalEnter,
          enterActive: styles.modalEnterActive,
          exit: styles.modalExit,
          exitActive: styles.modalExitActive,
          exitDone: styles.modalExitDone,
        }}
        mountOnEnter
      >
        <div className={styles.modal}>
          <div className={styles.modalContent}>
            {this.renderIcon()}
            <div className={styles.message}>{message}</div>
          </div>
        </div>
      </CSSTransition>
    );
  }
}
